export const calcCircumference = (radius: number) => 2 * radius * Math.PI;

export const calcStrokeOffset = (value = 10, radius: number) =>
  ((100 - value) / 100) * calcCircumference(radius);
